<section class="pageBanner relative">
    <div class="swiper" id="page-slider">
        <div class="swiper-wrapper">
            @for (item of bannerContent; track $index; let idx = $index;) {
            <div class="swiper-slide">
                <div class="pageBanner__items">
                    @if(idx == 0){
                    <picture>
                        <source media="(max-width:430px)" [srcset]="assetsCDNUrl+item.image_mob_url">
                        <source media="(min-width:431px)" [srcset]="assetsCDNUrl+item.image_url">
                        <img class="pageBanner__image" [ngSrc]="assetsCDNUrl + item.image_mob_url" [alt]="item.alt_text"
                            width="1920" height="652" fetchpriority="high">
                    </picture>
                    }
                    @if(idx != 0){
                    <picture>
                        <source media="(max-width:430px)" [srcset]="assetsCDNUrl+item.image_mob_url">
                        <source media="(min-width:431px)" [srcset]="assetsCDNUrl+item.image_url">
                        <img class="pageBanner__image" [ngSrc]="assetsCDNUrl + item.image_mob_url" [alt]="item.alt_text"
                            width="1920" height="652" loading="eager" fetchpriority="high">
                    </picture>
                    }
                    <div class="container">
                        <div class="pageBanner__content">
                            @if(idx == 0){
                            <h1 class="heading-primary-8xl md:!text-center mb-3 pageBanner__heading"
                                [ngClass]="item.class_name" [innerHTML]="item.title"></h1>
                            }
                            @if(idx != 0){
                            <h2 class="heading-primary-8xl md:!text-center mb-3 pageBanner__heading"
                                [ngClass]="item.class_name" [innerHTML]="item.title"></h2>
                            }
                            <div class="md:text-center editor-content pageBanner__subText" [ngClass]="item.class_name"
                                [innerHTML]="item.subtitle | safeHtml"></div>
                            <div class="md:text-center mt-3 md:mt-11">
                                <a [routerLink]="'/contact-us'" class="button button-orange button-rounded button-arrow"
                                    [title]="item.btn_text" (click)="handler_redirect(2)">{{item.btn_text}}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
    <div class="swiperArrow">
        <div class="swiper-pagination swiper-pagination-mb !-bottom-8"></div>
    </div>
</section>